export default {
    "zh": {
        "pageTitle": "SoulGen AI 图片生成器 - 角色创意独特视角",
        "pageDescription": "体验 SoulGen AI 图片生成器，让角色创意拥有独特视角，从角色设定、视觉参考和情绪出发创建富有表现力的图像。",
        "pageKeywords": "SoulGen AI, AI角色生成器, 角色设计, 图片制作, 免费AI图片, WeryAI",
        "generatorTitle": "SoulGen AI 图片生成器",
        "coreFeaturesTitle": "让角色创意拥有视觉表达",
        "startWithPersonalityTitle": "从个性开始",
        "startWithPersonalityDescription": "使用角色、态度和存在感，让角色不仅仅是视觉特征的列表。",
        "directTheMoodTitle": "引导情绪",
        "directTheMoodDescription": "设定光线、色彩、场景和视觉风格，让角色感觉在场景中自然舒适。",
        "developTheDetailsTitle": "发展细节",
        "developTheDetailsDescription": "使用变体改进轮廓、表情、服装和讲故事的小线索。",
        "creativeVariationsTitle": "创意变化",
        "creativeVariationsDescription": "快速生成同一角色的多种变体，探索不同表现形式和风格。",
        "howToUseTitle": "如何使用",
        "step1Title": "选择 SoulGen AI",
        "step1Description": "前往<span class=\"highlight-text\">\"AI图像生成\"</span>页面，在模型下拉菜单中选择 \"SoulGen AI\"。",
        "step2Title": "写角色设定",
        "step2Description": "描述个性、特征、角色和角色所属的世界。",
        "step3Title": "优化身份",
        "step3Description": "审查变体，持续改进讲述故事的视觉细节。",
        "youtubeTitle": "SoulGen AI 视频教程",
        "xPostsTitle": "SoulGen AI 社区动态",
        "exploreModelsTitle": "探索更多AI图像模型",
        "fluxTitle": "Flux",
        "midjourneyTitle": "Midjourney",
        "leonardoTitle": "Leonardo AI",
        "faqTitle": "常见问题解答",
        "ctaTitle": "从角色的视角开始",
        "ctaDescription": "将角色设定转化为富有表现力的视觉概念，留有优化空间",
        "ctaButton": "在 WeryAI 上试用 SoulGen AI",
        "ctaDisclaimer": "无需信用卡，立即开始创作"
    },
    "en": {
        "pageTitle": "SoulGen AI Image Generator - Character Concept with Distinct Perspective",
        "pageDescription": "Experience SoulGen AI image generator, give character concepts a distinct point of view, create expressive images from character notes, visual references and mood.",
        "pageKeywords": "SoulGen AI, AI character generator, character design, image creation, free AI image, WeryAI",
        "generatorTitle": "SoulGen AI Image Generator",
        "coreFeaturesTitle": "Give a Character Concept a Visual Voice",
        "startWithPersonalityTitle": "Start with Personality",
        "startWithPersonalityDescription": "Use role, attitude and presence to make the character more than a list of visual traits.",
        "directTheMoodTitle": "Direct the Mood",
        "directTheMoodDescription": "Set the light, colour, setting and visual style that makes the character feel at home in the scene.",
        "developTheDetailsTitle": "Develop the Details",
        "developTheDetailsDescription": "Use variations to improve the silhouette, expression, wardrobe and small storytelling cues.",
        "creativeVariationsTitle": "Creative Variations",
        "creativeVariationsDescription": "Quickly generate multiple variations of the same character to explore different expressions and styles.",
        "howToUseTitle": "How to Use",
        "step1Title": "Select SoulGen AI",
        "step1Description": "Go to the <span class=\"highlight-text\">\"AI Image Generation\"</span> page and select \"SoulGen AI\" from the model dropdown.",
        "step2Title": "Write the Character Note",
        "step2Description": "Describe the personality, features, role and the world the character belongs to.",
        "step3Title": "Refine the Identity",
        "step3Description": "Review variations and keep improving the visual details that tell the story.",
        "youtubeTitle": "SoulGen AI Video Tutorials",
        "xPostsTitle": "SoulGen AI Community Updates",
        "exploreModelsTitle": "Explore More AI Image Models",
        "fluxTitle": "Flux",
        "midjourneyTitle": "Midjourney",
        "leonardoTitle": "Leonardo AI",
        "faqTitle": "FAQ",
        "ctaTitle": "Start with the Character's Point of View",
        "ctaDescription": "Turn a character note into an expressive visual concept with room to refine",
        "ctaButton": "Try SoulGen AI on WeryAI",
        "ctaDisclaimer": "No credit card required, start creating now"
    },
    "ja": {
        "pageTitle": "SoulGen AI 画像ジェネレーター - 独自の視点を持つキャラクターコンセプト",
        "pageDescription": "SoulGen AI画像ジェネレーターを体験。キャラクターコンセプトに独自の視点を与え、キャラクターノート、ビジュアルリファレンス、ムードから表現豊かな画像を作成。",
        "pageKeywords": "SoulGen AI, AIキャラクタージェネレーター, キャラクターデザイン, 画像作成, 無料AI画像, WeryAI",
        "generatorTitle": "SoulGen AI 画像ジェネレーター",
        "coreFeaturesTitle": "キャラクターコンセプトにビジュアルボイスを与える",
        "startWithPersonalityTitle": "個性から始める",
        "startWithPersonalityDescription": "役割、態度、存在感を使って、キャラクターを視覚的特徴のリスト以上のものにします。",
        "directTheMoodTitle": "ムードを演出",
        "directTheMoodDescription": "キャラクターがシーンで居心地よく感じる光、色、設定、ビジュアルスタイルを設定します。",
        "developTheDetailsTitle": "詳細を発展",
        "developTheDetailsDescription": "バリエーションを使ってシルエット、表情、衣装、小さなストーリーテリングの手がかりを改善します。",
        "creativeVariationsTitle": "クリエイティブなバリエーション",
        "creativeVariationsDescription": "同じキャラクターの複数のバリエーションを素早く生成し、異なる表現とスタイルを探索します。",
        "howToUseTitle": "使用方法",
        "step1Title": "SoulGen AIを選択",
        "step1Description": "<span class=\"highlight-text\">\"AI画像生成\"</span>ページに移動し、モデルドロップダウンから\"SoulGen AI\"を選択します。",
        "step2Title": "キャラクターノートを書く",
        "step2Description": "個性、特徴、役割、キャラクターが属する世界を説明します。",
        "step3Title": "アイデンティティを洗練",
        "step3Description": "バリエーションをレビューし、ストーリーを伝える視覚的詳細を改善し続けます。",
        "youtubeTitle": "SoulGen AI ビデオチュートリアル",
        "xPostsTitle": "SoulGen AI コミュニティアップデート",
        "exploreModelsTitle": "他のAI画像モデルを探索",
        "fluxTitle": "Flux",
        "midjourneyTitle": "Midjourney",
        "leonardoTitle": "Leonardo AI",
        "faqTitle": "よくある質問",
        "ctaTitle": "キャラクターの視点から始める",
        "ctaDescription": "キャラクターノートを改善の余地がある表現豊かな視覚コンセプトに変換",
        "ctaButton": "WeryAIでSoulGen AIを試す",
        "ctaDisclaimer": "クレジットカード不要、今すぐ作成開始"
    },
    "ko": {
        "pageTitle": "SoulGen AI 이미지 생성기 - 독특한 관점을 가진 캐릭터 컨셉",
        "pageDescription": "SoulGen AI 이미지 생성기를 경험하세요. 캐릭터 컨셉에 독특한 관점을 부여하고 캐릭터 노트, 시각 참조, 분위기에서 표현력 있는 이미지를 생성하세요.",
        "pageKeywords": "SoulGen AI, AI 캐릭터 생성기, 캐릭터 디자인, 이미지 제작, 무료 AI 이미지, WeryAI",
        "generatorTitle": "SoulGen AI 이미지 생성기",
        "coreFeaturesTitle": "캐릭터 컨셉에 시각적 목소리 부여",
        "startWithPersonalityTitle": "성격으로 시작",
        "startWithPersonalityDescription": "역할, 태도, 존재감을 사용하여 캐릭터를 시각적 특성 목록 이상으로 만듭니다.",
        "directTheMoodTitle": "분위기 연출",
        "directTheMoodDescription": "캐릭터가 장면에서 편안함을 느끼게 하는 조명, 색상, 설정, 시각적 스타일을 설정합니다.",
        "developTheDetailsTitle": "세부사항 개발",
        "developTheDetailsDescription": "변형을 사용하여 실루엣, 표정, 의상, 작은 스토리텔링 단서를 개선합니다.",
        "creativeVariationsTitle": "크리에이티브 변형",
        "creativeVariationsDescription": "동일한 캐릭터의 여러 변형을 빠르게 생성하여 다양한 표현과 스타일을 탐색합니다.",
        "howToUseTitle": "사용 방법",
        "step1Title": "SoulGen AI 선택",
        "step1Description": "<span class=\"highlight-text\">\"AI 이미지 생성\"</span> 페이지로 이동하여 모델 드롭다운에서 \"SoulGen AI\"를 선택합니다.",
        "step2Title": "캐릭터 노트 작성",
        "step2Description": "성격, 특징, 역할, 캐릭터가 속한 세계를 설명합니다.",
        "step3Title": "정체성 개선",
        "step3Description": "변형을 검토하고 이야기를 전달하는 시각적 세부사항을 계속 개선합니다.",
        "youtubeTitle": "SoulGen AI 비디오 튜토리얼",
        "xPostsTitle": "SoulGen AI 커뮤니티 업데이트",
        "exploreModelsTitle": "더 많은 AI 이미지 모델 탐색",
        "fluxTitle": "Flux",
        "midjourneyTitle": "Midjourney",
        "leonardoTitle": "Leonardo AI",
        "faqTitle": "자주 묻는 질문",
        "ctaTitle": "캐릭터의 관점에서 시작",
        "ctaDescription": "캐릭터 노트를 개선의 여지가 있는 표현력 있는 시각적 컨셉으로 전환",
        "ctaButton": "WeryAI에서 SoulGen AI 사용해보기",
        "ctaDisclaimer": "신용카드 불필요, 지금 바로 제작 시작"
    },
    "tw": {
        "pageTitle": "SoulGen AI 圖片生成器 - 角色創意獨特視角",
        "pageDescription": "體驗 SoulGen AI 圖片生成器，讓角色創意擁有獨特視角，從角色設定、視覺參考和情緒出發創建富有表現力的圖像。",
        "pageKeywords": "SoulGen AI, AI角色生成器, 角色設計, 圖片製作, 免費AI圖片, WeryAI",
        "generatorTitle": "SoulGen AI 圖片生成器",
        "coreFeaturesTitle": "讓角色創意擁有視覺表達",
        "startWithPersonalityTitle": "從個性開始",
        "startWithPersonalityDescription": "使用角色、態度和存在感，讓角色不僅僅是視覺特徵的列表。",
        "directTheMoodTitle": "引導情緒",
        "directTheMoodDescription": "設定光線、色彩、場景和視覺風格，讓角色感覺在場景中自然舒適。",
        "developTheDetailsTitle": "發展細節",
        "developTheDetailsDescription": "使用變體改進輪廓、表情、服裝和講故事的小線索。",
        "creativeVariationsTitle": "創意變化",
        "creativeVariationsDescription": "快速生成同一角色的多種變體，探索不同表現形式和風格。",
        "howToUseTitle": "如何使用",
        "step1Title": "選擇 SoulGen AI",
        "step1Description": "前往<span class=\"highlight-text\">\"AI圖像生成\"</span>頁面，在模型下拉選單中選擇 \"SoulGen AI\"。",
        "step2Title": "寫角色設定",
        "step2Description": "描述個性、特徵、角色和角色所屬的世界。",
        "step3Title": "優化身份",
        "step3Description": "審查變體，持續改進講述故事的視覺細節。",
        "youtubeTitle": "SoulGen AI 視訊教學",
        "xPostsTitle": "SoulGen AI 社群動態",
        "exploreModelsTitle": "探索更多AI圖像模型",
        "fluxTitle": "Flux",
        "midjourneyTitle": "Midjourney",
        "leonardoTitle": "Leonardo AI",
        "faqTitle": "常見問題解答",
        "ctaTitle": "從角色的視角開始",
        "ctaDescription": "將角色設定轉化為富有表現力的視覺概念，留有優化空間",
        "ctaButton": "在 WeryAI 上試用 SoulGen AI",
        "ctaDisclaimer": "無需信用卡，立即開始創作"
    },
    "es": {
        "pageTitle": "Generador de Imágenes SoulGen AI - Concepto de Personaje con Perspectiva Distinta",
        "pageDescription": "Experimenta el generador de imágenes SoulGen AI, da a los conceptos de personajes un punto de vista distinto, crea imágenes expresivas desde notas de personajes, referencias visuales y estado de ánimo.",
        "pageKeywords": "SoulGen AI, generador de personajes AI, diseño de personajes, creación de imágenes, imagen AI gratis, WeryAI",
        "generatorTitle": "Generador de Imágenes SoulGen AI",
        "coreFeaturesTitle": "Da a un Concepto de Personaje una Voz Visual",
        "startWithPersonalityTitle": "Comenzar con Personalidad",
        "startWithPersonalityDescription": "Usa rol, actitud y presencia para hacer que el personaje sea más que una lista de rasgos visuales.",
        "directTheMoodTitle": "Dirigir el Estado de Ánimo",
        "directTheMoodDescription": "Establece la luz, color, escenario y estilo visual que hace que el personaje se sienta cómodo en la escena.",
        "developTheDetailsTitle": "Desarrollar los Detalles",
        "developTheDetailsDescription": "Usa variaciones para mejorar la silueta, expresión, vestuario y pequeñas pistas narrativas.",
        "creativeVariationsTitle": "Variaciones Creativas",
        "creativeVariationsDescription": "Genera rápidamente múltiples variaciones del mismo personaje para explorar diferentes expresiones y estilos.",
        "howToUseTitle": "Cómo Usar",
        "step1Title": "Seleccionar SoulGen AI",
        "step1Description": "Ve a la página de <span class=\"highlight-text\">\"Generación de Imagen AI\"</span> y selecciona \"SoulGen AI\" del menú desplegable de modelos.",
        "step2Title": "Escribir la Nota del Personaje",
        "step2Description": "Describe la personalidad, características, rol y el mundo al que pertenece el personaje.",
        "step3Title": "Refinar la Identidad",
        "step3Description": "Revisa variaciones y sigue mejorando los detalles visuales que cuentan la historia.",
        "youtubeTitle": "Tutoriales en Video de SoulGen AI",
        "xPostsTitle": "Actualizaciones de la Comunidad SoulGen AI",
        "exploreModelsTitle": "Explorar Más Modelos de Imagen AI",
        "fluxTitle": "Flux",
        "midjourneyTitle": "Midjourney",
        "leonardoTitle": "Leonardo AI",
        "faqTitle": "Preguntas Frecuentes",
        "ctaTitle": "Comienza con el Punto de Vista del Personaje",
        "ctaDescription": "Convierte una nota de personaje en un concepto visual expresivo con espacio para refinar",
        "ctaButton": "Probar SoulGen AI en WeryAI",
        "ctaDisclaimer": "No se requiere tarjeta de crédito, comienza a crear ahora"
    },
    "fr": {
        "pageTitle": "Générateur d'Images SoulGen AI - Concept de Personnage avec Perspective Distincte",
        "pageDescription": "Découvrez le générateur d'images SoulGen AI, donnez aux concepts de personnages un point de vue distinct, créez des images expressives à partir de notes de personnages, de références visuelles et d'ambiance.",
        "pageKeywords": "SoulGen AI, générateur de personnages AI, conception de personnages, création d'images, image AI gratuite, WeryAI",
        "generatorTitle": "Générateur d'Images SoulGen AI",
        "coreFeaturesTitle": "Donnez à un Concept de Personnage une Voix Visuelle",
        "startWithPersonalityTitle": "Commencer avec la Personnalité",
        "startWithPersonalityDescription": "Utilisez le rôle, l'attitude et la présence pour faire du personnage plus qu'une liste de traits visuels.",
        "directTheMoodTitle": "Diriger l'Ambiance",
        "directTheMoodDescription": "Définissez la lumière, la couleur, le décor et le style visuel qui font que le personnage se sent chez lui dans la scène.",
        "developTheDetailsTitle": "Développer les Détails",
        "developTheDetailsDescription": "Utilisez les variations pour améliorer la silhouette, l'expression, la garde-robe et les petits indices narratifs.",
        "creativeVariationsTitle": "Variations Créatives",
        "creativeVariationsDescription": "Générez rapidement plusieurs variations du même personnage pour explorer différentes expressions et styles.",
        "howToUseTitle": "Comment Utiliser",
        "step1Title": "Sélectionner SoulGen AI",
        "step1Description": "Allez sur la page <span class=\"highlight-text\">\"Génération d'Image AI\"</span> et sélectionnez \"SoulGen AI\" dans le menu déroulant des modèles.",
        "step2Title": "Écrire la Note du Personnage",
        "step2Description": "Décrivez la personnalité, les caractéristiques, le rôle et le monde auquel appartient le personnage.",
        "step3Title": "Affiner l'Identité",
        "step3Description": "Examinez les variations et continuez à améliorer les détails visuels qui racontent l'histoire.",
        "youtubeTitle": "Tutoriels Vidéo SoulGen AI",
        "xPostsTitle": "Mises à Jour de la Communauté SoulGen AI",
        "exploreModelsTitle": "Explorer Plus de Modèles d'Image AI",
        "fluxTitle": "Flux",
        "midjourneyTitle": "Midjourney",
        "leonardoTitle": "Leonardo AI",
        "faqTitle": "FAQ",
        "ctaTitle": "Commencer avec le Point de Vue du Personnage",
        "ctaDescription": "Transformez une note de personnage en concept visuel expressif avec de la place pour affiner",
        "ctaButton": "Essayer SoulGen AI sur WeryAI",
        "ctaDisclaimer": "Aucune carte de crédit requise, commencez à créer maintenant"
    },
    "de": {
        "pageTitle": "SoulGen AI Bildgenerator - Charakterkonzept mit eigener Perspektive",
        "pageDescription": "Erleben Sie den SoulGen AI Bildgenerator, geben Sie Charakterkonzepten einen eigenen Blickwinkel, erstellen Sie ausdrucksstarke Bilder aus Charakternotizen, visuellen Referenzen und Stimmung.",
        "pageKeywords": "SoulGen AI, AI Charaktergenerator, Charakterdesign, Bilderstellung, kostenlose AI Bilder, WeryAI",
        "generatorTitle": "SoulGen AI Bildgenerator",
        "coreFeaturesTitle": "Geben Sie einem Charakterkonzept eine visuelle Stimme",
        "startWithPersonalityTitle": "Mit Persönlichkeit beginnen",
        "startWithPersonalityDescription": "Verwenden Sie Rolle, Haltung und Präsenz, um den Charakter mehr als eine Liste visueller Merkmale zu machen.",
        "directTheMoodTitle": "Die Stimmung lenken",
        "directTheMoodDescription": "Setzen Sie das Licht, die Farbe, die Kulisse und den visuellen Stil, der den Charakter in der Szene heimisch fühlen lässt.",
        "developTheDetailsTitle": "Die Details entwickeln",
        "developTheDetailsDescription": "Verwenden Sie Variationen, um die Silhouette, den Ausdruck, die Garderobe und kleine Erzählhinweise zu verbessern.",
        "creativeVariationsTitle": "Kreative Variationen",
        "creativeVariationsDescription": "Generieren Sie schnell mehrere Variationen desselben Charakters, um verschiedene Ausdrücke und Stile zu erkunden.",
        "howToUseTitle": "Anleitung",
        "step1Title": "SoulGen AI auswählen",
        "step1Description": "Gehen Sie zur Seite <span class=\"highlight-text\">\"KI-Bildgenerierung\"</span> und wählen Sie \"SoulGen AI\" aus dem Modell-Dropdown-Menü.",
        "step2Title": "Die Charakternotiz schreiben",
        "step2Description": "Beschreiben Sie die Persönlichkeit, Merkmale, Rolle und die Welt, zu der der Charakter gehört.",
        "step3Title": "Die Identität verfeinern",
        "step3Description": "Überprüfen Sie Variationen und verbessern Sie weiterhin die visuellen Details, die die Geschichte erzählen.",
        "youtubeTitle": "SoulGen AI Video-Tutorials",
        "xPostsTitle": "SoulGen AI Community-Updates",
        "exploreModelsTitle": "Weitere KI-Bildmodelle erkunden",
        "fluxTitle": "Flux",
        "midjourneyTitle": "Midjourney",
        "leonardoTitle": "Leonardo AI",
        "faqTitle": "FAQ",
        "ctaTitle": "Beginnen Sie mit dem Blickwinkel des Charakters",
        "ctaDescription": "Verwandeln Sie eine Charakternotiz in ein ausdrucksstarkes visuelles Konzept mit Raum zur Verfeinerung",
        "ctaButton": "SoulGen AI auf WeryAI ausprobieren",
        "ctaDisclaimer": "Keine Kreditkarte erforderlich, jetzt mit dem Erstellen beginnen"
    },
    "ru": {
        "pageTitle": "Генератор изображений SoulGen AI - Концепт персонажа с особым ракурсом",
        "pageDescription": "Познакомьтесь с генератором изображений SoulGen AI, придайте концептам персонажей особую точку зрения, создавайте выразительные изображения из заметок о персонаже, визуальных референсов и настроения.",
        "pageKeywords": "SoulGen AI, генератор персонажей AI, дизайн персонажей, создание изображений, бесплатные AI изображения, WeryAI",
        "generatorTitle": "Генератор изображений SoulGen AI",
        "coreFeaturesTitle": "Придайте концепту персонажа визуальный голос",
        "startWithPersonalityTitle": "Начать с личности",
        "startWithPersonalityDescription": "Используйте роль, отношение и присутствие, чтобы сделать персонажа больше, чем список визуальных черт.",
        "directTheMoodTitle": "Задать настроение",
        "directTheMoodDescription": "Установите свет, цвет, обстановку и визуальный стиль, которые заставят персонажа чувствовать себя как дома в сцене.",
        "developTheDetailsTitle": "Разработать детали",
        "developTheDetailsDescription": "Используйте вариации для улучшения силуэта, выражения лица, гардероба и небольших повествовательных подсказок.",
        "creativeVariationsTitle": "Креативные вариации",
        "creativeVariationsDescription": "Быстро создавайте несколько вариаций одного и того же персонажа для изучения различных выражений и стилей.",
        "howToUseTitle": "Как использовать",
        "step1Title": "Выбрать SoulGen AI",
        "step1Description": "Перейдите на страницу <span class=\"highlight-text\">\"Генерация AI изображений\"</span> и выберите \"SoulGen AI\" из выпадающего меню моделей.",
        "step2Title": "Написать заметку о персонаже",
        "step2Description": "Опишите личность, особенности, роль и мир, к которому принадлежит персонаж.",
        "step3Title": "Доработать идентичность",
        "step3Description": "Просматривайте вариации и продолжайте улучшать визуальные детали, которые рассказывают историю.",
        "youtubeTitle": "Видеоуроки SoulGen AI",
        "xPostsTitle": "Обновления сообщества SoulGen AI",
        "exploreModelsTitle": "Исследовать больше AI моделей изображений",
        "fluxTitle": "Flux",
        "midjourneyTitle": "Midjourney",
        "leonardoTitle": "Leonardo AI",
        "faqTitle": "FAQ",
        "ctaTitle": "Начните с точки зрения персонажа",
        "ctaDescription": "Превратите заметку о персонаже в выразительный визуальный концепт с возможностью доработки",
        "ctaButton": "Попробовать SoulGen AI на WeryAI",
        "ctaDisclaimer": "Кредитная карта не требуется, начните творить сейчас"
    },
    "pl": {
        "pageTitle": "Generator obrazów SoulGen AI - Koncepcja postaci z własną perspektywą",
        "pageDescription": "Poznaj generator obrazów SoulGen AI, nadaj koncepcjom postaci wyraźny punkt widzenia, twórz ekspresyjne obrazy z notatek o postaciach, referencji wizualnych i nastroju.",
        "pageKeywords": "SoulGen AI, generator postaci AI, projektowanie postaci, tworzenie obrazów, darmowe obrazy AI, WeryAI",
        "generatorTitle": "Generator obrazów SoulGen AI",
        "coreFeaturesTitle": "Nadaj koncepcji postaci wizualny głos",
        "startWithPersonalityTitle": "Zacząć od osobowości",
        "startWithPersonalityDescription": "Użyj roli, postawy i obecności, aby uczynić postać czymś więcej niż listą cech wizualnych.",
        "directTheMoodTitle": "Kierować nastrojem",
        "directTheMoodDescription": "Ustaw światło, kolor, scenę i styl wizualny, który sprawia, że postać czuje się w scenie jak w domu.",
        "developTheDetailsTitle": "Rozwinąć szczegóły",
        "developTheDetailsDescription": "Użyj wariacji, aby poprawić sylwetkę, ekspresję, garderobę i małe wskazówki narracyjne.",
        "creativeVariationsTitle": "Kreatywne wariacje",
        "creativeVariationsDescription": "Szybko wygeneruj wiele wariacji tej samej postaci, aby zbadać różne wyrazy i style.",
        "howToUseTitle": "Jak używać",
        "step1Title": "Wybrać SoulGen AI",
        "step1Description": "Przejdź do strony <span class=\"highlight-text\">\"Generowanie obrazów AI\"</span> i wybierz \"SoulGen AI\" z menu rozwijalnego modeli.",
        "step2Title": "Napisać notatkę o postaci",
        "step2Description": "Opisz osobowość, cechy, rolę i świat, do którego należy postać.",
        "step3Title": "Dopracować tożsamość",
        "step3Description": "Przeglądaj wariacje i kontynuuj poprawianie szczegółów wizualnych, które opowiadają historię.",
        "youtubeTitle": "Samouczki wideo SoulGen AI",
        "xPostsTitle": "Aktualizacje społeczności SoulGen AI",
        "exploreModelsTitle": "Poznaj więcej modeli obrazów AI",
        "fluxTitle": "Flux",
        "midjourneyTitle": "Midjourney",
        "leonardoTitle": "Leonardo AI",
        "faqTitle": "FAQ",
        "ctaTitle": "Zacznij od punktu widzenia postaci",
        "ctaDescription": "Przekształć notatkę o postaci w ekspresyjną koncepcję wizualną z miejscem na dopracowanie",
        "ctaButton": "Wypróbuj SoulGen AI na WeryAI",
        "ctaDisclaimer": "Nie wymaga karty kredytowej, zacznij tworzyć teraz"
    },
    "pt": {
        "pageTitle": "Gerador de Imagens SoulGen AI - Conceito de Personagem com Perspectiva Distinta",
        "pageDescription": "Experimente o gerador de imagens SoulGen AI, dê aos conceitos de personagens um ponto de vista distinto, crie imagens expressivas a partir de notas de personagens, referências visuais e atmosfera.",
        "pageKeywords": "SoulGen AI, gerador de personagens AI, design de personagens, criação de imagens, imagem AI grátis, WeryAI",
        "generatorTitle": "Gerador de Imagens SoulGen AI",
        "coreFeaturesTitle": "Dê a um Conceito de Personagem uma Voz Visual",
        "startWithPersonalityTitle": "Começar com Personalidade",
        "startWithPersonalityDescription": "Use papel, atitude e presença para fazer do personagem mais do que uma lista de traços visuais.",
        "directTheMoodTitle": "Dirigir o Clima",
        "directTheMoodDescription": "Defina a luz, cor, cenário e estilo visual que fazem o personagem se sentir em casa na cena.",
        "developTheDetailsTitle": "Desenvolver os Detalhes",
        "developTheDetailsDescription": "Use variações para melhorar a silhueta, expressão, guarda-roupa e pequenas pistas narrativas.",
        "creativeVariationsTitle": "Variações Criativas",
        "creativeVariationsDescription": "Gere rapidamente múltiplas variações do mesmo personagem para explorar diferentes expressões e estilos.",
        "howToUseTitle": "Como usar",
        "step1Title": "Selecionar SoulGen AI",
        "step1Description": "Vá para a página <span class=\"highlight-text\">\"Geração de Imagem AI\"</span> e selecione \"SoulGen AI\" no menu suspenso de modelos.",
        "step2Title": "Escrever a Nota do Personagem",
        "step2Description": "Descreva a personalidade, características, papel e o mundo ao qual o personagem pertence.",
        "step3Title": "Refinar a Identidade",
        "step3Description": "Revise variações e continue melhorando os detalhes visuais que contam a história.",
        "youtubeTitle": "Tutoriais em vídeo SoulGen AI",
        "xPostsTitle": "Atualizações da comunidade SoulGen AI",
        "exploreModelsTitle": "Explorar mais modelos de imagem AI",
        "fluxTitle": "Flux",
        "midjourneyTitle": "Midjourney",
        "leonardoTitle": "Leonardo AI",
        "faqTitle": "FAQ",
        "ctaTitle": "Comece com o Ponto de Vista do Personagem",
        "ctaDescription": "Transforme uma nota de personagem em um conceito visual expressivo com espaço para refinar",
        "ctaButton": "Experimentar SoulGen AI no WeryAI",
        "ctaDisclaimer": "Não é necessário cartão de crédito, comece a criar agora"
    },
    "it": {
        "pageTitle": "Generatore di Immagini SoulGen AI - Concetto di Personaggio con Prospettiva Distinta",
        "pageDescription": "Sperimenta il generatore di immagini SoulGen AI, dai ai concetti di personaggi un punto di vista distinto, crea immagini espressive da note sui personaggi, riferimenti visivi e atmosfera.",
        "pageKeywords": "SoulGen AI, generatore di personaggi AI, design dei personaggi, creazione di immagini, immagine AI gratuita, WeryAI",
        "generatorTitle": "Generatore di Immagini SoulGen AI",
        "coreFeaturesTitle": "Dai a un Concetto di Personaggio una Voce Visiva",
        "startWithPersonalityTitle": "Iniziare con la Personalità",
        "startWithPersonalityDescription": "Usa ruolo, atteggiamento e presenza per rendere il personaggio più di un elenco di tratti visivi.",
        "directTheMoodTitle": "Dirigere l'Atmosfera",
        "directTheMoodDescription": "Imposta la luce, il colore, l'ambientazione e lo stile visivo che fanno sentire il personaggio a casa nella scena.",
        "developTheDetailsTitle": "Sviluppare i Dettagli",
        "developTheDetailsDescription": "Usa le variazioni per migliorare la silhouette, l'espressione, il guardaroba e i piccoli indizi narrativi.",
        "creativeVariationsTitle": "Variazioni Creative",
        "creativeVariationsDescription": "Genera rapidamente più variazioni dello stesso personaggio per esplorare diverse espressioni e stili.",
        "howToUseTitle": "Come Usare",
        "step1Title": "Selezionare SoulGen AI",
        "step1Description": "Vai alla pagina <span class=\"highlight-text\">\"Generazione Immagini AI\"</span> e seleziona \"SoulGen AI\" dal menu a tendina dei modelli.",
        "step2Title": "Scrivere la Nota del Personaggio",
        "step2Description": "Descrivi la personalità, le caratteristiche, il ruolo e il mondo a cui appartiene il personaggio.",
        "step3Title": "Raffinare l'Identità",
        "step3Description": "Esamina le variazioni e continua a migliorare i dettagli visivi che raccontano la storia.",
        "youtubeTitle": "Tutorial Video SoulGen AI",
        "xPostsTitle": "Aggiornamenti della Comunità SoulGen AI",
        "exploreModelsTitle": "Esplora Altri Modelli di Immagini AI",
        "fluxTitle": "Flux",
        "midjourneyTitle": "Midjourney",
        "leonardoTitle": "Leonardo AI",
        "faqTitle": "FAQ",
        "ctaTitle": "Inizia con il Punto di Vista del Personaggio",
        "ctaDescription": "Trasforma una nota del personaggio in un concetto visivo espressivo con spazio per raffinare",
        "ctaButton": "Prova SoulGen AI su WeryAI",
        "ctaDisclaimer": "Nessuna carta di credito richiesta, inizia a creare ora"
    },
    "ar": {
        "pageTitle": "مولد صور SoulGen AI - مفهوم الشخصية بمنظور مميز",
        "pageDescription": "جرب مولد صور SoulGen AI، امنح مفاهيم الشخصيات وجهة نظر مميزة، أنشئ صوراً تعبيرية من ملاحظات الشخصيات والمراجع البصرية والمزاج.",
        "pageKeywords": "SoulGen AI، مولد شخصيات AI، تصميم شخصيات، إنشاء صور، صورة AI مجانية، WeryAI",
        "generatorTitle": "مولد صور SoulGen AI",
        "coreFeaturesTitle": "امنح مفهوم الشخصية صوتاً بصرياً",
        "startWithPersonalityTitle": "البدء بالشخصية",
        "startWithPersonalityDescription": "استخدم الدور والموقف والحضور لجعل الشخصية أكثر من مجرد قائمة من السمات البصرية.",
        "directTheMoodTitle": "توجيه المزاج",
        "directTheMoodDescription": "حدد الضوء واللون والإعداد والأسلوب البصري الذي يجعل الشخصية تشعر بالراحة في المشهد.",
        "developTheDetailsTitle": "تطوير التفاصيل",
        "developTheDetailsDescription": "استخدم الاختلافات لتحسين الظل والتعبير والملابس والإشارات السردية الصغيرة.",
        "creativeVariationsTitle": "اختلافات إبداعية",
        "creativeVariationsDescription": "أنشئ بسرعة اختلافات متعددة لنفس الشخصية لاستكشاف تعبيرات وأنماط مختلفة.",
        "howToUseTitle": "كيفية الاستخدام",
        "step1Title": "اختر SoulGen AI",
        "step1Description": "انتقل إلى صفحة <span class=\"highlight-text\">\"توليد صور AI\"</span> واختر \"SoulGen AI\" من القائمة المنسدلة للنماذج.",
        "step2Title": "اكتب ملاحظة الشخصية",
        "step2Description": "صف الشخصية والمميزات والدور والعالم الذي تنتمي إليه الشخصية.",
        "step3Title": "صقل الهوية",
        "step3Description": "راجع الاختلافات واستمر في تحسين التفاصيل البصرية التي تروي القصة.",
        "youtubeTitle": "دروس فيديو SoulGen AI",
        "xPostsTitle": "تحديثات مجتمع SoulGen AI",
        "exploreModelsTitle": "استكشف المزيد من نماذج صور AI",
        "fluxTitle": "Flux",
        "midjourneyTitle": "Midjourney",
        "leonardoTitle": "Leonardo AI",
        "faqTitle": "الأسئلة الشائعة",
        "ctaTitle": "ابدأ بوجهة نظر الشخصية",
        "ctaDescription": "حول ملاحظة الشخصية إلى مفهوم بصري تعبيري مع مساحة للصقل",
        "ctaButton": "جرب SoulGen AI على WeryAI",
        "ctaDisclaimer": "لا حاجة لبطاقة ائتمان، ابدأ الإنشاء الآن"
    },
    "th": {
        "pageTitle": "เครื่องมือสร้างภาพ SoulGen AI - แนวคิดตัวละครด้วยมุมมองที่โดดเด่น",
        "pageDescription": "สัมผัสประสบการณ์เครื่องมือสร้างภาพ SoulGen AI มอบมุมมองที่โดดเด่นให้กับแนวคิดตัวละคร สร้างภาพที่แสดงออกจากโน้ตตัวละคร อ้างอิงภาพ และอารมณ์",
        "pageKeywords": "SoulGen AI, เครื่องมือสร้างตัวละคร AI, การออกแบบตัวละคร, การสร้างภาพ, ภาพ AI ฟรี, WeryAI",
        "generatorTitle": "เครื่องมือสร้างภาพ SoulGen AI",
        "coreFeaturesTitle": "มอบเสียงทางภาพให้กับแนวคิดตัวละคร",
        "startWithPersonalityTitle": "เริ่มต้นด้วยบุคลิกภาพ",
        "startWithPersonalityDescription": "ใช้บทบาท ทัศนคติ และการปรากฏตัวเพื่อทำให้ตัวละครมากกว่ารายการของลักษณะทางภาพ",
        "directTheMoodTitle": "กำกับอารมณ์",
        "directTheMoodDescription": "ตั้งค่าแสง สี ฉาก และสไตล์ภาพที่ทำให้ตัวละครรู้สึกเหมือนอยู่บ้านในฉาก",
        "developTheDetailsTitle": "พัฒนารายละเอียด",
        "developTheDetailsDescription": "ใช้รูปแบบต่างๆ เพื่อปรับปรุงเงา การแสดงออก เสื้อผ้า และคำใบ้การเล่าเรื่องเล็กๆ",
        "creativeVariationsTitle": "รูปแบบที่สร้างสรรค์",
        "creativeVariationsDescription": "สร้างรูปแบบต่างๆ ของตัวละครเดียวกันได้อย่างรวดเร็วเพื่อสำรวจการแสดงออกและสไตล์ที่แตกต่างกัน",
        "howToUseTitle": "วิธีใช้",
        "step1Title": "เลือก SoulGen AI",
        "step1Description": "ไปที่หน้า <span class=\"highlight-text\">\"การสร้างภาพ AI\"</span> และเลือก \"SoulGen AI\" จากเมนูแบบเลื่อนลงของโมเดล",
        "step2Title": "เขียนโน้ตตัวละคร",
        "step2Description": "อธิบายบุคลิกภาพ ลักษณะ บทบาท และโลกที่ตัวละครเป็นของ",
        "step3Title": "ปรับปรุงอัตลักษณ์",
        "step3Description": "ตรวจสอบรูปแบบต่างๆ และปรับปรุงรายละเอียดภาพที่บอกเรื่องราวต่อไป",
        "youtubeTitle": "บทเรียนวิดีโอ SoulGen AI",
        "xPostsTitle": "อัปเดตชุมชน SoulGen AI",
        "exploreModelsTitle": "สำรวจโมเดลภาพ AI เพิ่มเติม",
        "fluxTitle": "Flux",
        "midjourneyTitle": "Midjourney",
        "leonardoTitle": "Leonardo AI",
        "faqTitle": "คำถามที่พบบ่อย",
        "ctaTitle": "เริ่มต้นด้วยมุมมองของตัวละคร",
        "ctaDescription": "เปลี่ยนโน้ตตัวละครเป็นแนวคิดภาพที่แสดงออกพร้อมพื้นที่สำหรับปรับปรุง",
        "ctaButton": "ลอง SoulGen AI บน WeryAI",
        "ctaDisclaimer": "ไม่ต้องใช้บัตรเครดิต เริ่มสร้างเลยตอนนี้"
    },
    "da": {
        "pageTitle": "SoulGen AI Billedgenerator - Karakterkoncept med særskilt perspektiv",
        "pageDescription": "Oplev SoulGen AI billedgeneratoren, giv karakterkoncepter et særskilt synspunkt, skab udtryksfulde billeder fra karakternoter, visuelle referencer og stemning.",
        "pageKeywords": "SoulGen AI, AI karaktergenerator, karakterdesign, billedskabelse, gratis AI billede, WeryAI",
        "generatorTitle": "SoulGen AI Billedgenerator",
        "coreFeaturesTitle": "Giv et karakterkoncept en visuel stemme",
        "startWithPersonalityTitle": "Start med personlighed",
        "startWithPersonalityDescription": "Brug rolle, holdning og tilstedeværelse til at gøre karakteren mere end en liste over visuelle træk.",
        "directTheMoodTitle": "Lede stemningen",
        "directTheMoodDescription": "Indstil lyset, farven, scenen og den visuelle stil, der får karakteren til at føle sig hjemme i scenen.",
        "developTheDetailsTitle": "Udvikle detaljerne",
        "developTheDetailsDescription": "Brug variationer til at forbedre silhuetten, udtrykket, garderoben og små fortællehenvisninger.",
        "creativeVariationsTitle": "Kreative variationer",
        "creativeVariationsDescription": "Generer hurtigt flere variationer af den samme karakter for at udforske forskellige udtryk og stile.",
        "howToUseTitle": "Sådan bruges",
        "step1Title": "Vælg SoulGen AI",
        "step1Description": "Gå til siden <span class=\"highlight-text\">\"AI Billedgenerering\"</span> og vælg \"SoulGen AI\" fra modeldropdownen.",
        "step2Title": "Skriv karakternoten",
        "step2Description": "Beskriv personligheden, trækkene, rollen og den verden, karakteren tilhører.",
        "step3Title": "Forfine identiteten",
        "step3Description": "Gennemgå variationer og fortsæt med at forbedre de visuelle detaljer, der fortæller historien.",
        "youtubeTitle": "SoulGen AI Videovejledninger",
        "xPostsTitle": "SoulGen AI Fællesskabsopdateringer",
        "exploreModelsTitle": "Udforsk flere AI-billedmodeller",
        "fluxTitle": "Flux",
        "midjourneyTitle": "Midjourney",
        "leonardoTitle": "Leonardo AI",
        "faqTitle": "FAQ",
        "ctaTitle": "Start med karakterens synspunkt",
        "ctaDescription": "Forvandl en karakternote til et udtryksfuldt visuelt koncept med plads til at forfine",
        "ctaButton": "Prøv SoulGen AI på WeryAI",
        "ctaDisclaimer": "Intet kreditkort påkrævet, begynd at skabe nu"
    },
    "no": {
        "pageTitle": "SoulGen AI Bildegenerator - Karakterkonsept med særskilt perspektiv",
        "pageDescription": "Opplev SoulGen AI bildegeneratoren, gi karakterkonsepter et særskilt synspunkt, skap uttrykksfulle bilder fra karakternotater, visuelle referanser og stemning.",
        "pageKeywords": "SoulGen AI, AI karaktergenerator, karakterdesign, bildeopprettelse, gratis AI bilde, WeryAI",
        "generatorTitle": "SoulGen AI Bildegenerator",
        "coreFeaturesTitle": "Gi et karakterkonsept en visuell stemme",
        "startWithPersonalityTitle": "Start med personlighet",
        "startWithPersonalityDescription": "Bruk rolle, holdning og tilstedeværelse for å gjøre karakteren mer enn en liste over visuelle trekk.",
        "directTheMoodTitle": "Lede stemningen",
        "directTheMoodDescription": "Sett lyset, fargen, settingen og den visuelle stilen som får karakteren til å føle seg hjemme i scenen.",
        "developTheDetailsTitle": "Utvikle detaljene",
        "developTheDetailsDescription": "Bruk variasjoner for å forbedre silhuetten, uttrykket, garderoben og små fortellerhenvisninger.",
        "creativeVariationsTitle": "Kreative variasjoner",
        "creativeVariationsDescription": "Generer raskt flere variasjoner av den samme karakteren for å utforske forskjellige uttrykk og stiler.",
        "howToUseTitle": "Hvordan bruke",
        "step1Title": "Velg SoulGen AI",
        "step1Description": "Gå til <span class=\"highlight-text\">\"AI Bildegenerering\"</span>-siden og velg \"SoulGen AI\" fra modellnedtrekksmenyen.",
        "step2Title": "Skriv karakternotatet",
        "step2Description": "Beskriv personligheten, trekkene, rollen og verden karakteren tilhører.",
        "step3Title": "Forbedre identiteten",
        "step3Description": "Gjennomgå variasjoner og fortsett å forbedre de visuelle detaljene som forteller historien.",
        "youtubeTitle": "SoulGen AI Videoveiledninger",
        "xPostsTitle": "SoulGen AI Samfunnsoppdateringer",
        "exploreModelsTitle": "Utforsk flere AI-bildemodeller",
        "fluxTitle": "Flux",
        "midjourneyTitle": "Midjourney",
        "leonardoTitle": "Leonardo AI",
        "faqTitle": "FAQ",
        "ctaTitle": "Start med karakterens synspunkt",
        "ctaDescription": "Forvandl et karakternotat til et uttrykkfullt visuelt konsept med rom til å forbedre",
        "ctaButton": "Prøv SoulGen AI på WeryAI",
        "ctaDisclaimer": "Intet kredittkort påkrevd, begynn å skape nå"
    },
    "nl": {
        "pageTitle": "SoulGen AI Afbeeldinggenerator - Karakterconcept met Eigen Perspectief",
        "pageDescription": "Ervaar de SoulGen AI afbeeldinggenerator, geef karakterconcepten een eigen gezichtspunt, creëer expressieve afbeeldingen vanuit karakternotities, visuele referenties en sfeer.",
        "pageKeywords": "SoulGen AI, AI karaktergenerator, karakterontwerp, afbeeldingcreatie, gratis AI afbeelding, WeryAI",
        "generatorTitle": "SoulGen AI Afbeeldinggenerator",
        "coreFeaturesTitle": "Geef een karakterconcept een visuele stem",
        "startWithPersonalityTitle": "Begin met persoonlijkheid",
        "startWithPersonalityDescription": "Gebruik rol, houding en aanwezigheid om het karakter meer te maken dan een lijst visuele kenmerken.",
        "directTheMoodTitle": "Stuur de sfeer",
        "directTheMoodDescription": "Stel het licht, de kleur, de setting en de visuele stijl in die het karakter zich thuis laat voelen in de scène.",
        "developTheDetailsTitle": "Ontwikkel de details",
        "developTheDetailsDescription": "Gebruik variaties om het silhouet, de uitdrukking, de garderobe en kleine vertelwijzers te verbeteren.",
        "creativeVariationsTitle": "Creatieve variaties",
        "creativeVariationsDescription": "Genereer snel meerdere variaties van hetzelfde karakter om verschillende uitdrukkingen en stijlen te verkennen.",
        "howToUseTitle": "Hoe te gebruiken",
        "step1Title": "Selecteer SoulGen AI",
        "step1Description": "Ga naar de pagina <span class=\"highlight-text\">\"AI Afbeeldinggeneratie\"</span> en selecteer \"SoulGen AI\" uit het modeldropdownmenu.",
        "step2Title": "Schrijf de karakternotitie",
        "step2Description": "Beschrijf de persoonlijkheid, kenmerken, rol en de wereld waartoe het karakter behoort.",
        "step3Title": "Verfijn de identiteit",
        "step3Description": "Bekijk variaties en blijf de visuele details verbeteren die het verhaal vertellen.",
        "youtubeTitle": "SoulGen AI Videotutorials",
        "xPostsTitle": "SoulGen AI Community-updates",
        "exploreModelsTitle": "Ontdek meer AI-afbeeldingmodellen",
        "fluxTitle": "Flux",
        "midjourneyTitle": "Midjourney",
        "leonardoTitle": "Leonardo AI",
        "faqTitle": "FAQ",
        "ctaTitle": "Begin met het gezichtspunt van het karakter",
        "ctaDescription": "Transformeer een karakternotitie in een expressief visueel concept met ruimte om te verfijnen",
        "ctaButton": "Probeer SoulGen AI op WeryAI",
        "ctaDisclaimer": "Geen creditcard vereist, begin nu met creëren"
    },
    "id": {
        "pageTitle": "Generator Gambar SoulGen AI - Konsep Karakter dengan Perspektif Berbeda",
        "pageDescription": "Rasakan generator gambar SoulGen AI, berikan konsep karakter sudut pandang yang berbeda, buat gambar ekspresif dari catatan karakter, referensi visual, dan suasana.",
        "pageKeywords": "SoulGen AI, generator karakter AI, desain karakter, pembuatan gambar, gambar AI gratis, WeryAI",
        "generatorTitle": "Generator Gambar SoulGen AI",
        "coreFeaturesTitle": "Berikan Konsep Karakter Suara Visual",
        "startWithPersonalityTitle": "Mulai dengan Kepribadian",
        "startWithPersonalityDescription": "Gunakan peran, sikap, dan kehadiran untuk membuat karakter lebih dari sekadar daftar ciri visual.",
        "directTheMoodTitle": "Mengarahkan Suasana",
        "directTheMoodDescription": "Atur cahaya, warna, latar, dan gaya visual yang membuat karakter merasa di rumah dalam adegan.",
        "developTheDetailsTitle": "Kembangkan Detail",
        "developTheDetailsDescription": "Gunakan variasi untuk meningkatkan siluet, ekspresi, lemari pakaian, dan petunjuk cerita kecil.",
        "creativeVariationsTitle": "Variasi Kreatif",
        "creativeVariationsDescription": "Hasilkan dengan cepat beberapa variasi karakter yang sama untuk menjelajahi berbagai ekspresi dan gaya.",
        "howToUseTitle": "Cara Menggunakan",
        "step1Title": "Pilih SoulGen AI",
        "step1Description": "Buka halaman <span class=\"highlight-text\">\"Generasi Gambar AI\"</span> dan pilih \"SoulGen AI\" dari dropdown model.",
        "step2Title": "Tulis Catatan Karakter",
        "step2Description": "Jelaskan kepribadian, fitur, peran, dan dunia tempat karakter berada.",
        "step3Title": "Sempurnakan Identitas",
        "step3Description": "Tinjau variasi dan terus tingkatkan detail visual yang menceritakan kisahnya.",
        "youtubeTitle": "Tutorial Video SoulGen AI",
        "xPostsTitle": "Pembaruan Komunitas SoulGen AI",
        "exploreModelsTitle": "Jelajahi Lebih Banyak Model Gambar AI",
        "fluxTitle": "Flux",
        "midjourneyTitle": "Midjourney",
        "leonardoTitle": "Leonardo AI",
        "faqTitle": "FAQ",
        "ctaTitle": "Mulai dengan Sudut Pandang Karakter",
        "ctaDescription": "Ubah catatan karakter menjadi konsep visual ekspresif dengan ruang untuk menyempurnakan",
        "ctaButton": "Coba SoulGen AI di WeryAI",
        "ctaDisclaimer": "Tidak perlu kartu kredit, mulai buat sekarang"
    },
    "tr": {
        "pageTitle": "SoulGen AI Görsel Oluşturucu - Ayrı Perspektife Sahip Karakter Konsepti",
        "pageDescription": "SoulGen AI görsel oluşturucuyu deneyimleyin, karakter konseptlerine farklı bir bakış açısı verin, karakter notlarından, görsel referanslardan ve ruh halinden etkileyici görseller oluşturun.",
        "pageKeywords": "SoulGen AI, AI karakter oluşturucu, karakter tasarımı, görsel oluşturma, ücretsiz AI görsel, WeryAI",
        "generatorTitle": "SoulGen AI Görsel Oluşturucu",
        "coreFeaturesTitle": "Bir Karakter Konseptine Görsel Bir Ses Verin",
        "startWithPersonalityTitle": "Kişilikle Başlayın",
        "startWithPersonalityDescription": "Karakteri görsel özelliklerin bir listesinden daha fazlası yapmak için rol, tavır ve varlık kullanın.",
        "directTheMoodTitle": "Ruh Halini Yönetin",
        "directTheMoodDescription": "Karakterin sahnede kendini evinde hissetmesini sağlayan ışığı, rengi, ortamı ve görsel stili ayarlayın.",
        "developTheDetailsTitle": "Detayları Geliştirin",
        "developTheDetailsDescription": "Silueti, ifadeyi, gardırobu ve küçük hikaye anlatma ipuçlarını geliştirmek için varyasyonları kullanın.",
        "creativeVariationsTitle": "Yaratıcı Varyasyonlar",
        "creativeVariationsDescription": "Farklı ifadeleri ve stilleri keşfetmek için aynı karakterin birden fazla varyasyonunu hızlıca oluşturun.",
        "howToUseTitle": "Nasıl Kullanılır",
        "step1Title": "SoulGen AI'ı Seçin",
        "step1Description": "<span class=\"highlight-text\">\"AI Görsel Oluşturma\"</span> sayfasına gidin ve model açılır menüsünden \"SoulGen AI\"ı seçin.",
        "step2Title": "Karakter Notunu Yazın",
        "step2Description": "Karakterin kişiliğini, özelliklerini, rolünü ve ait olduğu dünyayı açıklayın.",
        "step3Title": "Kimliği Geliştirin",
        "step3Description": "Varyasyonları inceleyin ve hikayeyi anlatan görsel detayları geliştirmeye devam edin.",
        "youtubeTitle": "SoulGen AI Video Eğitimleri",
        "xPostsTitle": "SoulGen AI Topluluk Güncellemeleri",
        "exploreModelsTitle": "Daha Fazla AI Görsel Modeli Keşfedin",
        "fluxTitle": "Flux",
        "midjourneyTitle": "Midjourney",
        "leonardoTitle": "Leonardo AI",
        "faqTitle": "SSS",
        "ctaTitle": "Karakterin Bakış Açısıyla Başlayın",
        "ctaDescription": "Bir karakter notunu, geliştirme alanı olan etkileyici bir görsel konsepte dönüştürün",
        "ctaButton": "WeryAI'da SoulGen AI'ı Deneyin",
        "ctaDisclaimer": "Kredi kartı gerekmez, hemen oluşturmaya başlayın"
    }
}
